module.exports = __webpack_public_path__ + "static/img/iron-rod_256.c0b1777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iron-rod_256.png
// module id = JORU
// module chunks = 0